import React, { useEffect, useRef, useState } from 'react';
import './ViolationPage.scss';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import {
  getFilterData,
  getJsonFromStorage,
  getPaginationOpts, getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import { getViolationData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import { VIOLATIONS_MODULE } from '../../../configs/moduleNames';
import {
  deleteViolation, importViolation, loadViolationsById, loadViolationsList,
} from '../actions';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import { Icons, Button } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { POPUP_LIST_NAME } from '../../../configs';
import { addGlobalPopUpWrapper, closeAllPopupWrapper } from '../../InformationScreenWrapper/actions';
import getDefaultSort from '../../../utils/getDefaultSort';
import {
  dateFormatter, dateTimeFormatter, getLegalEntityName, userFIOFormatter, violationStatusFormatter,
} from '../../../utils/formatters';
import TabMenu from '../../../components/base/TabMenu/TabMenu';
import FilterModal from '../../FilterTemplate/components/FilterModal';
import { PAGE_TYPE } from '../../FilterTemplate/components/filter-settings';
import RegistryImport from '../../RegionRegistry/components/RegistryImport';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import ViolationForm from './ViolationForm';
import { showGlobalConfirm } from '../../System/actions';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import ExportInterface from '../../System/components/ExportInterface';
import TextSearchInput from '../../../components/fields/TextInput/TextSearchInput';

export default function ViolationsPage() {
  const blockRef = useRef(null);
  const dispatch = useDispatch();
  const store = useStore();
  const { updatePeriod } = useSelector(getSystemData);
  const {
    violationList,
    violationListMeta,
    loadingViolationList,
  } = useSelector(getViolationData);
  const [selectedTab, setSelectedTab] = useState('driver');
  const filterName = 'violation-filter';
  const [isOpenFilter, setOpenFilter] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { formatMessage } = useIntl();
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[VIOLATIONS_MODULE].violationListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: { ...getValues(), type: [selectedTab] },
      sort,
    };
    const p1 = dispatch(loadViolationsList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const handleImport = files => {
    if (!files) {
      return;
    }
    const data = new FormData();
    for (let i = 0, len = files.length; i < len; i++) {
      const file = files[i];
      data.append('file', file);
    }
    dispatch(importViolation(data))
      .then(() => successNotification('Импорт нарушений', 'Процесс импорта прошел успешно'))
      .catch(response => errorNotification('Импорт нарушений', getResponseError(response)));
    setShowImport(false);
  };

  useEffect(() => {
    loadData();
  }, [selectedTab]);

  const handleEdit = item => event => {
    if (!item) {
      return;
    }

    dispatch(loadViolationsById(item?.id)).then(() => {
      setIsEdit(true);
      setShowForm(true);
    }).catch(responseLogWithNotification);
  };

  const handleDelete = item => event => {
    if (!item?.id) {
      return;
    }
    dispatch(showGlobalConfirm({
      confirmMessage: <div className="f2">Удалить нарушение — {item?.id || ''}</div>,
      confirmButtonText: 'Удалить',
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteViolation(item.id)).then(() => {
        loadData();
        successNotification('Удаление нарушения', 'Удаление прошло успешно');
      }).catch(response => {
        errorNotification('Удаление нарушения', getResponseError(response));
      });
    }).catch(() => {});
    return false;
  };

  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];

    return classes.join(' ');
  };

  useEffect(() => () => dispatch((closeAllPopupWrapper())), []);

  const conditionalColumn = selectedTab === 'driver' ? [{
    dataField: 'driver',
    text: 'Водитель',
    formatter: (driver, item) => (item?.driver_id && driver
      ? userFIOFormatter({ last_name: driver?.driver_last_name, first_name: driver?.driver_first_name, middle_name: driver?.driver_middle_name })
      : item.driver_full_name),
    disableSort: true,
  },
  {
    dataField: 'driver_document',
    headerClassName: 'fine-amount-column',
    text: 'Документ водителя, удостоверяющий личность либо иной документ',
  },
  ] : [{
    dataField: 'applicant',
    text: 'Перевозчик',
    formatter: getLegalEntityName,
    disableSort: true,
  }];

  const violationColumns = [
    ...conditionalColumn,
    {
      dataField: 'resolution_number',
      headerClassName: 'number-violation-column',
      text: 'Номер постановления',
    },
    {
      dataField: 'resolution_at',
      headerClassName: 'resolution-date-column',
      text: 'Дата постановления',
      formatter: dateFormatter,
    },
    {
      dataField: 'koap',
      headerClassName: 'article-column',
      text: 'Состав АПН',
      // formatter: item => item.name,
    },
    {
      dataField: 'uin',
      headerClassName: 'uin-column',
      text: 'УИН',
    },
    {
      dataField: 'status',
      headerClassName: 'short-status-column',
      formatter: violationStatusFormatter,
      text: 'Статус',
    },
    {
      dataField: 'created_at',
      headerClassName: 'violation-date-column',
      text: 'Дата и время внесения записи',
      formatter: dateTimeFormatter,
    },
    {
      dataField: 'sum',
      headerClassName: 'fine-amount-column',
      text: 'Сумма штрафа',
    },
  ];

  const renderContextMenu = item => (
    <div className="more-wrapper">
      <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}>
        Редактировать
      </Button>
      <Button variant="link" className="w-100 more-button delete" onClick={handleDelete(item)}>
        Удалить
      </Button>
    </div>
  );

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={renderContextMenu(item)}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  useEffect(() => reset(getFilterData(filterName, {})), []);
  const {
    getValues, watch, control, reset,
  } = useForm({ defaultValues: getJsonFromStorage('violation-page-filter', {}) });

  const handleClose = () => {
    setShowImport(false);
    setShowForm(false);
    setIsEdit(false);
  };

  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem(filterName, JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const [sort, setSort] = useState(getDefaultSort(violationColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);
  return (
    <div className="page violation-page">
      <TimerLoader global loading={loadingViolationList} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.violations' })}</div>
        <TabMenu options={[{ value: 'applicant', label: 'Штрафы перевозчиков' }, { value: 'driver', label: 'Штрафы водителей' }]} onSelectOptions={i => setSelectedTab(i.value)} selectedTab={selectedTab} />
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
          />
          <div className="filter-sep" />
          <Button
            variant="second"
            onClick={() => {
              setShowImport(true);
            }}
          >
            <Icons
              customIcon
              className="file-download"
              width={24}
              height={24}
              icon="import"
            />
          </Button>
          <div className="filter-sep" />
          <ExportInterface page="violations" exporter="violations" getValues={getValues} />
          <div className="filter-sep" />
          <Button variant="second" onClick={() => setOpenFilter(true)}>
            <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
          </Button>
          <div className="filter-sep" />
          <Button variant="second" onClick={() => setShowForm(true)}>
            <Icons
              customIcon
              className="file-download"
              width={24}
              height={24}
              icon="plus"
            />
          </Button>
          {isOpenFilter
            ? (
              <FilterModal
                control={control}
                onClose={() => setOpenFilter(false)}
                getValues={getValues}
                reset={reset}
                defaultValues={{}}
                page={PAGE_TYPE.VIOLATIONS}
              />
            )
            : null}
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                data={violationList}
                rowClassFormatter={rowClassFormatter}
                columns={violationColumns}
                name="violations-list"
                changeSort={changeSort}
                sort={sort}
                onDoubleClickByRow={item => {
                  dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.VIOLATION_DETAIL, id: item?.id })));
                }}
                settingsFormatter={moreFormatter}
                renderContextMenu={renderContextMenu}
              />
            </div>
          </div>
          <Pagination meta={violationListMeta} list={violationList} handleChangeMeta={loadData} />
          {showImport ? <RegistryImport title="Импорт нарушения" handleImport={handleImport} onClose={() => handleClose()} /> : null}
          {showForm ? <ViolationForm loadData={loadData} isEdit={isEdit} onClose={() => handleClose()} /> : null}
        </div>
      </div>
    </div>
  );
}
